export default class MarginService {
    static calculateMargePercentage(purchasePrice, salePrice) {
        if (purchasePrice === null || salePrice === null) {
            return 0;
        }
        if (salePrice === 0) {
            return 0;
        }
        if (purchasePrice === 0 && salePrice !== null) {
            return 100;
        }
        return ((salePrice - purchasePrice) / purchasePrice) * 100;
    }

    static calculateSalePrice(purchasePrice, margin) {
        let purchasePriceFloat = parseFloat(purchasePrice);
        if (isNaN(purchasePriceFloat)) {
            purchasePriceFloat = 0;
        }
        let marge = parseFloat(margin);
        if (isNaN(marge)) {
            marge = 0;
        }

        return purchasePriceFloat + (purchasePriceFloat * marge / 100);
    }

}
